<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="noindent"><a id="dedi"><em>For Bonnie Hearn Hill, who taught me the value of Gemini time</em></a></p></div><a id="dedi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?345bdc55